export enum AppPages {
    INTRO,
    PERMISSIONS,
    SEARCH,
    TRAINING,
    ACCOUNT
}
